import { el, enGB, fr, it, ja, mk, nl } from 'date-fns/locale';
import { store } from 'store';

function getLocale() {
  const lang = store.getState().appState.language;
  if (!lang) return enGB; // fallback

  switch (lang) {
    case 'en':
      return enGB;
    case 'it':
      return it;
    case 'ja':
      return ja;
    case 'el':
      return el;
    case 'fr':
      return fr;
    case 'nl':
      return nl;
    case 'mk':
      return mk;
    default:
      return enGB;
  }
}

export default getLocale;
